import React from 'react'
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { STATUS } from 'state/requestStatus/reducer';
import styled from 'styled-components'
import Color from 'constants/colors'
import {CloseIcon} from 'components/static/icons'

const Container = styled.div`
  margin-top: -50px
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 30px;
`;

const Message = styled.h4`
  margin-top: -50px
  display: block;
  width: calc(100% - 48px);
  text-align: center;
`;

const Dismiss = styled.div`
  margin: -50px 10px;
  width: 18px;
  height: 28px;
`;

const LoadingTexture = styled.div`
  margin-top: -50px;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  background-color: ${Color('yellow')};
  height: 3px;
`;

const SuccessfulTexture = styled.div`
  margin-top: -50px
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  background-color: mediumspringgreen;
  height: 3px;
`;

const ErrorTexture = styled.div`
  margin-top: -50px
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  background-color: red;
  height: 30px;
`;


class MessageBanner extends React.Component {
  dismissBanner = () => {
    const { store } = this.context;
    store.dispatch("CLEAR_MESSAGES");
  }

  render() {
    const { requestStatus } = this.props;
    let message = null;
    let bannerTexture = null;
    switch (requestStatus.status) {
      case STATUS.LOADING:
        bannerTexture = <LoadingTexture/>
        break;
      case STATUS.SUCCESSFUL:
        bannerTexture = <SuccessfulTexture/>
        break;
      case STATUS.FAILURE:
        bannerTexture = <ErrorTexture/>
        message = requestStatus.messages.join("\n");
        break;
      default:
        break;
    }

    return(
      <Sticky enabled={true} top={50} bottomBoundary={1200}>
        {requestStatus.status !== STATUS.NONE && 
        <React.Fragment>
          <Sticky>
            {bannerTexture}
            {requestStatus.status === STATUS.FAILURE &&
            <Container>
              <Message>{message}</Message>
              <Dismiss onClick={this.dismissBanner}>
                <CloseIcon color="#fff"/>
              </Dismiss>
            </Container>
            }
          </Sticky>
        </React.Fragment>
        }
      </Sticky>
    );
  }
}

MessageBanner.contextTypes = {
  store: PropTypes.object
}

function mapStateToProps(state) {
  const { requestStatus } = state;
  return { requestStatus };
}

export default connect(mapStateToProps, {})(withRouter(MessageBanner));




// WEBPACK FOOTER //
// ./src/components/static/message-banner.js